import { makeStyles, useTheme, Box, Typography, Grid } from '@material-ui/core';
import React__default from 'react';
import CenterContainer from '../../theme/CenterContainer.js';
import PropTypes__default from 'prop-types';
import { textStyleType } from '../../common/PropShapes.js';
import CustomButton from '../../widgets/button/custom-button/CustomButton.js';
import { retrieveContentfulImage } from '../../common/image.js';
import { BUTTON_TYPES } from '../../common/constant.js';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    gridItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    ma: {
      margin: "auto"
    },
    iconItem: {
      width: theme.spacing(12.5),
      height: theme.spacing(12.5)
    },
    cta: {
      marginTop: theme.spacing(5)
    },
    text: {
      color: theme.palette.grey[0]
    },
    textContained: {
      color: theme.palette.text.black
    }
  };
});
var ColumnTiles = function ColumnTiles(_ref) {
  var subtitle = _ref.subtitle,
    title = _ref.title,
    titleStyle = _ref.titleStyle,
    subtitleStyle = _ref.subtitleStyle,
    bgColor = _ref.bgColor,
    gridColumns = _ref.gridColumns,
    elements = _ref.elements,
    gridSpacing = _ref.gridSpacing,
    buttons = _ref.buttons,
    onButtonClick = _ref.onButtonClick;
  var classes = useStyles();
  var theme = useTheme();
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    pt: 10
  }, /*#__PURE__*/React__default.createElement(CenterContainer, {
    maxWidth: theme.breakpoints.width("lg")
  }, /*#__PURE__*/React__default.createElement(Box, {
    px: 2,
    pb: 10
  }, subtitle && /*#__PURE__*/React__default.createElement(Box, {
    textAlign: "center",
    pb: 2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: subtitleStyle && subtitleStyle.headingVariant ? subtitleStyle.headingVariant : "overline",
    align: subtitleStyle && subtitleStyle.textAlignment ? subtitleStyle.textAlignment.toLowerCase() : "center",
    className: classes.subtitleText
  }, subtitle)), title && /*#__PURE__*/React__default.createElement(Box, {
    pb: 4,
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: titleStyle && titleStyle.headingVariant ? titleStyle.headingVariant : "h1",
    component: "h2",
    align: titleStyle && titleStyle.textAlignment ? titleStyle.textAlignment.toLowerCase() : "center",
    className: classes.heading
  }, title)), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: gridSpacing ? gridSpacing : 2
  }, elements === null || elements === void 0 ? void 0 : elements.map(function (item, index) {
    var _item$image, _item$image2, _item$image3;
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: gridColumns ? 12 / gridColumns : 3,
      key: index,
      className: classes.gridItem
    }, (item === null || item === void 0 || (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      className: classes.iconItem,
      src: retrieveContentfulImage(item === null || item === void 0 || (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.url, {
        width: 100,
        height: 100
      }),
      alt: (item === null || item === void 0 || (_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.title) || ""
    }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/React__default.createElement(Box, {
      mt: 1.5
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "h5",
      component: "div"
    }, item === null || item === void 0 ? void 0 : item.title)), (item === null || item === void 0 ? void 0 : item.description) && /*#__PURE__*/React__default.createElement(Box, {
      mt: 1.5
    }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
      markdownString: item === null || item === void 0 ? void 0 : item.description
    })));
  })), buttons === null || buttons === void 0 ? void 0 : buttons.map(function (i) {
    var _i$button, _BUTTON_TYPES$i$butto, _i$button3, _BUTTON_TYPES$i$butto2, _i$button4, _i$button5, _BUTTON_TYPES$i$butto3, _i$button6, _i$button7;
    return /*#__PURE__*/React__default.createElement(Box, {
      key: i === null || i === void 0 || (_i$button = i.button) === null || _i$button === void 0 ? void 0 : _i$button.id,
      textAlign: "center"
    }, /*#__PURE__*/React__default.createElement(CustomButton, {
      className: classes.cta,
      onClick: function onClick() {
        var _i$button2;
        return onButtonClick(i === null || i === void 0 || (_i$button2 = i.button) === null || _i$button2 === void 0 ? void 0 : _i$button2.id);
      },
      variant: ((_BUTTON_TYPES$i$butto = BUTTON_TYPES[i === null || i === void 0 || (_i$button3 = i.button) === null || _i$button3 === void 0 ? void 0 : _i$button3.type]) === null || _BUTTON_TYPES$i$butto === void 0 ? void 0 : _BUTTON_TYPES$i$butto.variant) || "contained",
      color: (_BUTTON_TYPES$i$butto2 = BUTTON_TYPES[i === null || i === void 0 || (_i$button4 = i.button) === null || _i$button4 === void 0 ? void 0 : _i$button4.type]) === null || _BUTTON_TYPES$i$butto2 === void 0 ? void 0 : _BUTTON_TYPES$i$butto2.color,
      href: i === null || i === void 0 || (_i$button5 = i.button) === null || _i$button5 === void 0 ? void 0 : _i$button5.url
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "subtitle1",
      component: "span",
      className: (((_BUTTON_TYPES$i$butto3 = BUTTON_TYPES[i === null || i === void 0 || (_i$button6 = i.button) === null || _i$button6 === void 0 ? void 0 : _i$button6.type]) === null || _BUTTON_TYPES$i$butto3 === void 0 ? void 0 : _BUTTON_TYPES$i$butto3.color) || "primary") === "primary" ? classes.textContained : classes.text
    }, i === null || i === void 0 || (_i$button7 = i.button) === null || _i$button7 === void 0 ? void 0 : _i$button7.label)));
  }))));
};
ColumnTiles.propTypes = {
  subtitle: PropTypes__default.string,
  title: PropTypes__default.string,
  titleStyle: PropTypes__default.shape(textStyleType),
  subtitleStyle: PropTypes__default.shape(textStyleType),
  bgColor: PropTypes__default.string,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  elements: PropTypes__default.array,
  gridSpacing: PropTypes__default.number,
  buttons: PropTypes__default.array,
  onButtonClick: PropTypes__default.func
};

export { ColumnTiles, ColumnTiles as default };
//# sourceMappingURL=ColumnTiles.js.map
